<template>
  <div id="grass">
    <app-navbar></app-navbar>
    <div class="container pt-lg-4" style="min-height: 80vh;">
      <div class="col-lg-10 offset-lg-1 text-left">
        <h2 class="text-center">
          {{ "FoodStreet.label" | staticTranslation }}
        </h2>
        <p style="text-align: justify;"
           class="intro"
           v-html="htmlTextOne">
        </p>
        <p style="text-align: justify;"
           class="intro"
           v-html="htmlTextTwo"></p>
        <p style="text-align: justify;"
           class="intro"
           v-html="htmlTextThree"></p>
        <p style="text-align: justify;"
           class="intro"
           v-html="htmlTextFour"></p>

        <div class="msff-info-desktop">
          <img
              src="@/assets/Foodstreet/2026/msff-info.svg"
              :alt="infoGraphicLabel"
              class="msff-info msff-info-combined"
          />
        </div>
        <div class="msff-info-mobile">
          <img
              src="@/assets/Foodstreet/2026/msff-map.svg"
              :alt="mapGraphicLabel"
              class="msff-info-part msff-info-part-icon"
          />
          <img
              src="@/assets/Foodstreet/2026/msff-vegetarian.svg"
              :alt="vegetarianGraphicLabel"
              class="msff-info-part msff-info-part-icon"
          />
          <img
              src="@/assets/Foodstreet/2026/msff-logo.svg"
              alt="Maraton Street Food Festival"
              class="msff-info-part msff-info-part-logo"
          />
        </div>
      </div>

      <div class="col-lg-10 offset-lg-1">
        <div
            v-for="restaurant in restaurants"
            :key="restaurant.key"
            class="row g-0 pt-lg-4 pb-lg-4 pt-4 pb-4 align-items-stretch"
        >
          <div class="col-12 col-lg-4 ps-3 position-relative overflow-hidden color-red">
            <img
                :src="restaurant.image"
                :alt="`${foodImageLabel}: ${restaurantText(restaurant, 'name')}`"
                class="img-cover"
            />
          </div>
          <div class="col-12 col-lg-8 color-shadow px-4 py-4">
            <h3>{{ restaurantText(restaurant, "name") }}</h3>
            <h4>{{ restaurantText(restaurant, "address") }}</h4>
            <p class="mb-1 time">
              {{ restaurantText(restaurant, "hours") }}
            </p>
            <p style="text-align: justify;">
              {{ restaurantText(restaurant, "dish") }}
            </p>
            <a
                :href="restaurant.website"
                target="_blank"
                rel="noopener noreferrer"
            >
              <div type="button" class="btn mb-lg-4 mb-4">
                {{ "FoodStreet.button" | staticTranslation }}
              </div>
            </a>
          </div>
        </div>
      </div>
      <image-modal ref="imageModal"/>
    </div>
    <app-footer></app-footer>
  </div>
</template>

<script>
import navbar from "@/components/base/navbar";
import footer from "@/components/base/footer";
import ImageModal from "@/components/base/ImageModal";

export default {
  name: "FoodStreet",
  components: {
    "image-modal": ImageModal,
    "app-navbar": navbar,
    "app-footer": footer,
  },
  computed: {
    htmlTextOne() {
      return this.$options.filters.staticTranslation("FoodStreet.textOne");
    },
    htmlTextTwo() {
      return this.$options.filters.staticTranslation("FoodStreet.textTwo");
    },
    htmlTextThree() {
      return this.$options.filters.staticTranslation("FoodStreet.textThree");
    },
    htmlTextFour() {
      return this.$options.filters.staticTranslation("FoodStreet.textFour");
    },
    foodImageLabel() {
      return this.$options.filters.staticTranslation("FoodStreet.foodImage");
    },
    infoGraphicLabel() {
      return this.$options.filters.staticTranslation("FoodStreet.infoGraphic");
    },
    mapGraphicLabel() {
      return this.$options.filters.staticTranslation("FoodStreet.mapGraphic");
    },
    vegetarianGraphicLabel() {
      return this.$options.filters.staticTranslation("FoodStreet.vegetarianGraphic");
    },
  },
  data() {
    return {
      restaurants: [
        {
          key: "bep",
          image: require("@/assets/Foodstreet/2026/01-bep.jpg"),
          website: "https://www.facebook.com/profile.php?id=61567473034046",
        },
        {
          key: "bistro-bastardo",
          image: require("@/assets/Foodstreet/2026/02-bistro-bastardo.jpg"),
          website: "https://bistrobastardo.com/",
        },
        {
          key: "bucheck",
          image: require("@/assets/Foodstreet/2026/03-bucheck.jpg"),
          website: "https://www.facebook.com/bucheckbrno",
        },
        {
          key: "burger-inn",
          image: require("@/assets/Foodstreet/2026/04-burger-inn.jpg"),
          website: "https://burger-inn.cz/",
        },
        {
          key: "cafe-bar-morgal",
          image: require("@/assets/Foodstreet/2026/05-cafe-bar-morgal.jpg"),
          website: "https://www.morgal.cz/",
        },
        {
          key: "cosmopolis-grill",
          image: require("@/assets/Foodstreet/2026/06-cosmopolis-grill.jpg"),
          website: "https://www.facebook.com/cosmopolisgrillBRNO",
        },
        {
          key: "don-pintxos",
          image: require("@/assets/Foodstreet/2026/07-don-pintxos.jpg"),
          website: "https://www.donpintxos.cz/",
        },
        {
          key: "efi-hostinec-zelnak",
          image: require("@/assets/Foodstreet/2026/08-efi-hostinec-zelnak.jpg"),
          website: "https://www.efihostinec.cz/zelnak/",
        },
        {
          key: "restaurace-gusto",
          image: require("@/assets/Foodstreet/2026/09-restaurace-gusto.jpg"),
          website: "https://gustoplzenka.cz/",
        },
        {
          key: "chicken-inn",
          image: require("@/assets/Foodstreet/2026/10-chicken-inn.jpg"),
          website: "https://chickeninn.cz/menu",
        },
        {
          key: "lokal-u-caipla",
          image: require("@/assets/Foodstreet/2026/12-lokal-u-caipla.jpg"),
          website: "https://lokal-ucaipla.ambi.cz/cz/",
        },
        {
          key: "singha-thai",
          image: require("@/assets/Foodstreet/2026/11-singha-thai.jpg"),
          website: "https://www.singhathairestaurant.cz/",
        },
        {
          key: "terapie-wine-bar",
          image: require("@/assets/Foodstreet/2026/13-terapie-wine-bar.jpg"),
          website: "https://www.wineterapie.cz/",
        },
        {
          key: "tatarak-bistro",
          image: require("@/assets/Foodstreet/2026/14-tatarak-bistro.jpg"),
          website: "https://tatarakbistro.cz/",
        },
      ],
    };
  },
  methods: {
    restaurantText(restaurant, field) {
      return this.$options.filters.staticTranslation(
          `FoodStreet.restaurants.${restaurant.key}.${field}`
      );
    },
  },
};
</script>

<style scoped>
h1 {
  font-size: 3.5em;
  padding-top: 3em;
  padding-bottom: 50px;
  font-family: "Transcript Pro";
}

h2 {
  padding-top: 7rem;
  padding-bottom: 2em;
  font-size: 2.5em;
  font-family: "Transcript Pro";
}

h3 {
  margin-bottom: 0;
  padding-top: 0.7rem;
  font-size: 1.8rem;
  font-family: "Transcript Pro";
}

h4 {
  margin-bottom: 0;
  padding-top: 0.1rem;
  font-family: "Transcript Pro";
  font-size: 1.2rem;
}

h5 {
  color: black;
  font-size: 1.4em;
  font-family: "Transcript Pro";
}

p {
  font-family: "Transcript Mono";
  b {
    font-family: "Transcript Pro";
  }
}

#grass {
  background-color: #FFCE6D;
  height: 100vh;
}

.table td,
.table,
th {
  border: none;
}

.table th {
  font-family: "Transcript Pro";
  font-size: 1.5rem;
}

.table td {
  font-family: "Transcript Mono";
  font-size: 1rem;
}

.table td span {
  padding-right: 20px;
}

.redBalloneHalf {
  position: absolute;
  text-align: end;
  right: 0;
  width: 10%;
  top: 300%;
}

.crossBallone {
  width: 12%;
  position: absolute;
  top: 12%;
  left: 2%;
}

.color-red {
  /* no more fixed aspect‐ratio */
  /* we want this flex‐item to stretch to the row height: */
  display: flex;
  align-items: center;      /* vertical centering of the img */
  justify-content: center;  /* horizontal centering if the img is narrower */
  overflow: hidden;
  background-color: #eae7d6;
  padding-left: 1rem;
}

.img-cover {
  width: 100%;
  height: auto;
  object-fit: contain;
  object-position: center;
  position: static;
  margin-left: 1rem;
}

.msff-info {
  display: block;
  width: 100%;
  height: auto;
  margin: 0.75rem 0 1.5rem;
}

.msff-info-desktop {
  overflow: hidden;
}

.msff-info-combined {
  /* The supplied SVG has transparent space on the right. Offset its visible
     artwork so the three items are optically centered in the content column. */
  transform: translateX(18%);
}

.msff-info-mobile {
  display: none;
}

@media screen and (max-width: 575px) {
  .msff-info-desktop {
    display: none;
  }

  .msff-info-mobile {
    display: block;
    overflow: hidden;
    margin: 1rem 0 1.5rem;
  }

  .msff-info-part {
    display: block;
    width: 100%;
    height: auto;
  }

  .msff-info-part-icon {
    transform: translateX(18%);
  }

  .msff-info-part-logo {
    transform: translateX(19.2%);
  }

  .color-red {
    background-color: #eae7d6;
    min-height: 14em;
  }
}

.color-shadow {
  background-color: #eae7d6;
}

.box-red {
  z-index: -1;
  position: absolute;
  height: 200vh;
  text-align: end;
  top: 80%;
  right: 0;
  width: 55%;
  background-color: #eae7d6;
}

.btn {
  padding: 4px 12px;
  border-radius: 0px;
  color: #152326;
  font-family: "Transcript Pro";
  background-color: #FFCE6D;
}

.btn:hover {
  background-color: #152326;
  color: #eae7d6;
}

.time {
  padding-top: 0;
}

.smallYellowBrickBallone {
  width: 13%;
  z-index: 1;
  position: absolute;
  text-align: end;
  right: 4%;
  top: 140vh;
}

.whiteBalls {
  width: 6%;
  position: absolute;
  top: 220vh;
  left: 5%;
}
</style>
